import SuperText from '../tiptap/SuperText';
import { CalendarScheduler } from './calendar_scheduler';
import { Calendly } from './calendly';
import { GooglePicker } from './google_picker';
import { ImageUploader } from './image_uploader';
import Loader from './loader';
import { PhoneInput } from './phone_input';
import { Signature } from './signature';
import { StripePayment } from './stripe_payment';

export default {
  Calendly,
  PhoneInput,
  Signature,
  StripePayment,
  GooglePicker,
  CalendarScheduler,
  Loader,
  ImageUploader,
  SuperText,
};
